import { Controller } from "@hotwired/stimulus"
import { event } from "jquery"

export default class extends Controller {
  connect() {
    console.log("Generic connected!")
    this.loadReferredPatients()
    this.restoreSidebarState()
  }

  // Sidebar collapse — persisted per browser via localStorage so the user's
  // choice survives reloads. Useful for non-consultant sp_types whose patient
  // list is short and not worth permanent screen real estate.
  toggleSidebar() {
    const collapsed = $("#generic-page-row").hasClass("sidebar-collapsed")
    this.applySidebarState(!collapsed)
    try { localStorage.setItem("genericSidebarCollapsed", (!collapsed).toString()) } catch (_) {}
  }

  restoreSidebarState() {
    let collapsed = false
    try { collapsed = localStorage.getItem("genericSidebarCollapsed") === "true" } catch (_) {}
    this.applySidebarState(collapsed)
  }

  applySidebarState(collapsed) {
    const $row = $("#generic-page-row")
    const $form = $("#generic-form-col")
    const $side = $("#generic-sidebar-col")
    const $expand = $("#generic-sidebar-expand-btn")
    if (!$row.length) return

    if (collapsed) {
      $row.addClass("sidebar-collapsed")
      $side.hide()
      $form.removeClass("col-8").addClass("col-12")
      $expand.show()
    } else {
      $row.removeClass("sidebar-collapsed")
      $side.show()
      $form.removeClass("col-12").addClass("col-8")
      $expand.hide()
    }
  }

  loadReferredPatients() {
    const TOKEN = window.TOKEN || window.readCookie("_priac_jwt");
    const container = document.getElementById('referred-patients-list');
    if (!container) return;

    $.ajax({
      url: '/generic/referred_patients',
      headers: { "Authorization": `Token ${TOKEN}` },
      success: function(data) {
        // Cache the consultant flag globally so selectReferredPatient can
        // decide whether to render the visit-history tab strip.
        window._isConsultant = !!data.is_consultant;

        const patients = data.patients || [];
        if (patients.length === 0) {
          const emptyMsg = window._isConsultant ? "No appointments today" : "No referred patients today";
          container.innerHTML = `<p class="text-muted text-center p-3 mb-0">${emptyMsg}</p>`;
          return;
        }

        let html = '';
        patients.forEach(p => {
          const statusColor = p.has_report ? '#22c55e' : '#f59e0b';
          const statusText = p.has_report ? 'Done' : 'Pending';
          const refBadges = p.referred_by.split(', ').map(r =>
            `<span style="font-size:9px; padding:1px 5px; border-radius:3px; background:${r === 'Octa' ? '#e0f2fe' : '#f0fdf4'}; color:${r === 'Octa' ? '#0369a1' : '#166534'};">${r}</span>`
          ).join(' ');
          html += `<div style="padding:10px 14px; border-bottom:1px solid #f1f5f9; cursor:pointer;" data-action="click->generic#selectReferredPatient" data-appointment-id="${p.appointment_id}" data-patient-id="${p.patient_id}"
            onmouseover="this.style.background='#f8fafc'" onmouseout="if(!this.classList.contains('active-referred')) this.style.background='white'">
            <div style="display:flex; justify-content:space-between; align-items:center;">
              <div>
                <strong style="font-size:13px;">${p.patient_name}</strong>
                <span style="font-size:11px; color:#94a3b8; margin-left:6px;">${p.patient_uid}</span>
              </div>
              <span style="font-size:10px; font-weight:600; color:${statusColor};">${statusText}</span>
            </div>
            <div style="margin-top:3px; font-size:11px; color:#64748b;">
              ${p.visit_time || ''} ${refBadges}
            </div>
          </div>`;
        });
        html += '';
        container.innerHTML = html;
      },
      error: function() {
        container.innerHTML = '<p class="text-danger text-center p-3 mb-0">Error loading referrals</p>';
      }
    });
  }

  selectReferredPatient(event) {
    const row = event.currentTarget;
    const patientId = row.getAttribute('data-patient-id');
    const appointmentId = row.getAttribute('data-appointment-id');

    // Highlight selected row
    document.querySelectorAll('#referred-patients-list > div').forEach(r => {
      r.style.background = 'white';
      r.style.borderLeft = 'none';
      r.classList.remove('active-referred');
    });
    row.style.background = '#d4f0f7';
    row.style.borderLeft = '3px solid #1E9BB7';
    row.classList.add('active-referred');

    // Load patient data into the form
    const TOKEN = window.TOKEN || window.readCookie("_priac_jwt");
    const HOST = window.location.origin;

    const block = this;
    block.showVisitLoader();
    $.ajax({
      url: `${HOST}/api/v1/patients/${patientId}`,
      headers: { "Authorization": `Token ${TOKEN}` },
      success: (res) => {
        const patientData = res.payload;
        fillPatientData(patientData);
        // Set the appointment_id so Save Report can use it
        $("#generic_report_appointment_id").val(appointmentId);
        $("#appointment_id").val(appointmentId);
        $(".submit-buttons").attr("data-appointmentid", appointmentId);
        // Load the report for this appointment — hide loader once the partial
        // re-renders into .generic-report-data (or on error).
        $.get(`/generic/get_report?appointment_id=${appointmentId}`)
          .always(function () { block.hideVisitLoader(); });

        // Mirror the top-search flow: populate appointment tabs for consultants
        // only. For other sp_types we just clear the strip — the row stays in
        // the DOM so subsequent navigations aren't broken.
        block.applyAppointmentTabs(res);

        block.loadPatientCategories(patientId);

        // Fetch and show AI summary modal
        $.ajax({
          url: `${HOST}/generic/ai_summary?patient_id=${patientId}&appointment_id=${appointmentId}`,
          headers: { "Authorization": `Token ${TOKEN}` },
          method: 'GET',
          success: function(summaryData) {
            if (summaryData && (summaryData.chiefComplaints || summaryData.clinicalStatus || summaryData.categorySummary || summaryData.clinicalImpression)) {
              block.showAISummaryModal(summaryData, patientData);
            }
          }
        });
      },
      error: () => block.hideVisitLoader()
    });
  }

  showAISummaryModal(summaryData, patientData) {
    const modalHtml = this.buildAISummaryModalHtml(summaryData, patientData);
    if (!modalHtml) return;

    $('#aiSummaryModal').remove();
    $('.modal-container').html(modalHtml);

    // Targeted cleanup just for the AI summary modal — without this, closing
    // it leaves the dark .modal-backdrop on the page and locks body scrolling.
    // Scoped to #aiSummaryModal so it does NOT touch other modals (lab reports
    // etc.) which Bootstrap can dispose on its own.
    $('#aiSummaryModal').off('hidden.bs.modal.cleanup').on('hidden.bs.modal.cleanup', function () {
      $(this).remove();
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open');
    });

    $('#aiSummaryModal').modal('show');
  }

  buildAISummaryModalHtml(summaryData, patientData) {
    const chiefComplaints = summaryData.chiefComplaints || '';
    const clinicalImpression = summaryData.clinicalImpression || summaryData.differentialDiagnosis || '';
    const clinicalStatus = summaryData.clinicalStatus || summaryData.categorySummary || {};
    const holistic = summaryData.holisticDashboard || {};
    const redFlags = summaryData.redFlagsDetected || [];
    const specialistNotes = summaryData.specialistNotes || [];
    const referrals = summaryData.alliedReferrals || [];

    const hasContent = chiefComplaints || clinicalImpression || Object.keys(clinicalStatus).length > 0;
    if (!hasContent) return null;

    const patientInfo = patientData ? { uid: patientData.uid || 'N/A', fullName: patientData.full_name || 'Unknown Patient' } : { uid: 'N/A', fullName: 'Unknown Patient' };

    const statusLabels = { globalHealth: 'Global Health', painSummary: 'Pain Summary', diseaseActivity: 'Disease Activity', functionalImpact: 'Functional Impact', compliance: 'Compliance', jointPath: 'Joint Assessment', systemic: 'Systemic', gut: 'Gut', psych: 'Psychological', ayurvedic: 'Ayurvedic', currentMedications: 'Current Medications', otherMedications: 'Other Medications', pastMedicalHistory: 'Past Medical History', previousTestsTreatment: 'Previous Tests & Treatment', patientPerspective: 'Patient Perspective (ICE)' };
    let clinicalStatusHtml = '';
    for (const [key, value] of Object.entries(clinicalStatus)) {
      if (value && value.trim()) {
        const label = statusLabels[key] || key.replace(/([A-Z])/g, ' $1').trim();
        clinicalStatusHtml += `<div class="mb-2"><small class="text-uppercase font-weight-bold text-muted">${label}</small><p class="mb-0" style="font-size:0.9rem;">${value}</p></div>`;
      }
    }

    const holisticLabels = { sleepRoutine: 'Sleep Routine', dietHabits: 'Diet & Habits', stressLifeEvents: 'Stress & Life Events', wellbeingSnapshot: 'Wellbeing Snapshot', substanceUse: 'Substance Use' };
    let holisticHtml = '';
    for (const [key, value] of Object.entries(holistic)) {
      if (value && value.trim() && value !== 'Not assessed' && value !== 'Not reported') {
        const label = holisticLabels[key] || key.replace(/([A-Z])/g, ' $1').trim();
        holisticHtml += `<div class="mb-2"><small class="text-uppercase font-weight-bold text-muted">${label}</small><p class="mb-0" style="font-size:0.9rem;">${value}</p></div>`;
      }
    }

    return `
      <style>
        #aiSummaryModal .modal-body { max-height: 80vh; overflow-y: auto; padding: 20px 24px; }
        #aiSummaryModal .section-title { font-size: 1.05rem; font-weight: 700; color: #C9A84C; margin: 18px 0 10px; padding-bottom: 4px; border-bottom: 1px solid #eee; }
      </style>
      <div class="modal fade" id="aiSummaryModal" tabindex="-1">
        <div class="modal-dialog modal-lg">
          <div class="modal-content" style="border:none;border-radius:10px;overflow:hidden;">
            <div class="modal-header" style="background:linear-gradient(135deg,#0d5e6e,#1E9BB7);padding:14px 24px;">
              <div>
                <span style="font-size:1.2rem;font-weight:700;color:white;">Intelligence Summary</span>
                <span style="color:rgba(255,255,255,0.8);margin-left:15px;font-size:0.95rem;">${patientInfo.fullName} (${patientInfo.uid})</span>
              </div>
              <button type="button" class="close text-white" data-dismiss="modal"><span>&times;</span></button>
            </div>
            <div class="modal-body">
              ${redFlags.length > 0 ? `<div style="background:#fff5f5;border:1px solid #fed7d7;border-left:4px solid #e53e3e;border-radius:4px;padding:8px 14px;margin-bottom:14px;color:#c53030;font-size:0.9rem;"><b>Red Flags:</b> ${redFlags.join('; ')}</div>` : ''}
              ${chiefComplaints ? `<div class="section-title">Chief Complaints</div><p style="font-size:0.95rem;">${chiefComplaints}</p>` : ''}
              ${clinicalImpression ? `<div class="section-title">Clinical Impression</div><p style="font-size:0.95rem;">${clinicalImpression}</p>` : ''}
              ${clinicalStatusHtml ? `<div class="row"><div class="col-md-${holisticHtml ? '6' : '12'}"><div class="section-title">Clinical Status</div>${clinicalStatusHtml}</div>${holisticHtml ? `<div class="col-md-6"><div class="section-title">Lifestyle & Wellbeing</div>${holisticHtml}</div>` : ''}</div>` : ''}
              ${specialistNotes.length > 0 ? `
              <div style="margin-top:14px;">
                <div class="section-title">Specialist Notes</div>
                ${specialistNotes.map(n => `
                  <div style="padding:8px 14px;background:#fafafa;border:1px solid #eee;border-radius:4px;margin-bottom:6px;">
                    <div style="font-size:0.8rem;font-weight:600;color:#1E9BB7;">${n.department} <span style="font-weight:400;color:#94a3b8;">— ${n.specialist}</span></div>
                    <div style="font-size:0.9rem;margin-top:3px;">${n.note}</div>
                  </div>`).join('')}
              </div>` : ''}
              ${referrals.length > 0 ? `
              <div style="margin-top:14px;">
                <div class="section-title">Suggested Referrals</div>
                <div>${referrals.map(r => `<span style="display:inline-block;padding:4px 12px;margin:2px 4px 2px 0;background:#f5f5f5;border:1px solid #ddd;border-radius:3px;font-size:0.85rem;color:#555;">${r}</span>`).join('')}</div>
              </div>` : ''}
              <p class="text-center mt-3 mb-0" style="font-size:0.8rem;color:#bbb;">This automated summary is for reference only. Clinical judgment should always take precedence.</p>
            </div>
            <div class="modal-footer" style="padding:10px 24px;border-top:1px solid #eee;">
              <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  // Tabs render for every sp_type now. Past visits are read-only (enforced
  // server-side in Front::GenericController#get_report via @editable, and in
  // Api::V1::GenericReportsController via appointment_editable?). The earlier
  // consultant-only gate broke the top-search auto-load chain for ayurveda /
  // physio / dietician / psychologist by emptying .appts before the auto-fire
  // selector ran.
  applyAppointmentTabs(res){
    this.appointmentTabs(res);
  }

  appointmentTabs(res, type){
    var def = null;
    var completedAppointments = res.payload.appointments.filter(a => (a.status == "completed" || a.status == "paid"))

    if (completedAppointments.length == 5 && type != "all"){
      def = `<li class="p-1 text-theme"> 
          <span class="badge appointment-tabs badge-sm badge-warning"
            data-action="click->generic#loadAllAppointments"
            data-patientid="${res.payload.id}"
            >
              Load All
          </span> 
        </li>`;
    }
    $(".appts").html(def);

    for (let index = completedAppointments.length - 1; index >= 0; index--) {
      var appt = completedAppointments[index];
      var visit_date = new Date(Date.parse(appt.visit_date)).toDateString()
      var bage = '';
      
      if (  index == 0  ){
        bage = "bg-theme"
      }

      $(".appts").append(`
        <li class="p-1 text-theme"> 
          <span class="badge appointment-tabs badge-sm badge-theme ${bage}"
            data-action="click->generic#fillAppointment" id="appointmentTab${appt.id}"
            data-prescriptionId="${appt.prescription_id || ''}" 
            data-appointmentId="${appt.id}">
              ${visit_date}
          </span> 
        </li>
      `)
    }
  }

  fillAppointment(event){
    var block = this;
    console.log("event", event)
    var appointmentId = $(event.target).attr("data-appointmentid")
    $(".appts span").removeClass("bg-theme")
    $(event.target).addClass("bg-theme")

    // Show a loader so the user has visual feedback during the two AJAX calls
    // (appointment fetch + get_report render). Hidden by the
    // 'fillAppointmentDone' handler bound below.
    block.showVisitLoader()

    // Fill Investigations by getting the full appointment details
    $.ajax({
      url: `${HOST}/api/v1/appointments/${appointmentId}`,
      headers: { "Authorization": `Token ${TOKEN}` },
      success:  function(res){
        var appointment = res.payload
        if (appointment){
          // Fill Appointment Fields
          for (const k in appointment) {
            var apptVal = appointment[k] || "";
            var $apptElement = $(`#appointment_${k}`)
            
            if(!$($apptElement).is("select")){
              $(`input[name="appointment[${k}]"]`).val(apptVal)
            }else if ($apptElement.is(":checkbox")){
              $(`#appointment_${k}`).prop('checked', apptVal);
            }
            else if(k.indexOf("_id") == -1){
              $(`button[data-id='appointment_${k}']`).trigger("click")
              $(`button[data-id='appointment_${k}']`)
                .next(".dropdown-menu")
                .find(`span:contains(${ humanize(apptVal) })`)
                .parent().trigger("click")
            }else{
              $(`#appointment_${k}`).val(apptVal).trigger('change')
            }
          }

          $("#appointment_id").val(appointment.id)
          $(".submit-buttons").attr("data-appointmentid", appointment.id)
          
          // Fill Investigations by getting the full appointment details
          $.ajax({
            url: `${HOST}/generic/get_report?appointment_id=${appointment.id}`,
            headers: { "Authorization": `Token ${TOKEN}` },
            success:  function(res){
              // After report loads, notify that fillAppointment is done
              $(document).trigger('fillAppointmentDone', [appointment.id]);
              block.hideVisitLoader()
            },
            error: function(){ block.hideVisitLoader() }
          })
        } else {
          block.hideVisitLoader()
        }
      },
      error: function(res){
        console.log(res)
        block.hideVisitLoader()
      }
    })
  }

  // Lightweight overlay shown while a visit's data is being fetched/rendered.
  // Injected once into .generic-report-data; toggled by fillAppointment.
  showVisitLoader(){
    var $host = $(".generic-report-data")
    if (!$host.length) return
    if (!$("#visit-loader-overlay").length) {
      $host.css("position", "relative").append(`
        <div id="visit-loader-overlay" style="
          position: absolute; inset: 0; z-index: 50;
          background: rgba(255,255,255,0.75);
          display: flex; flex-direction: column; align-items: center; justify-content: center;
          gap: 10px; font-size: 13px; color: #475569; font-weight: 500;
        ">
          <div style="
            width: 36px; height: 36px;
            border: 3px solid #cbd5e1; border-top-color: #1E9BB7;
            border-radius: 50%; animation: visit-loader-spin 0.7s linear infinite;
          "></div>
          <div>Loading visit&hellip;</div>
        </div>
        <style>
          @keyframes visit-loader-spin { to { transform: rotate(360deg); } }
        </style>
      `)
    } else {
      $("#visit-loader-overlay").show()
    }
  }

  hideVisitLoader(){
    $("#visit-loader-overlay").remove()
  }

  fillPatient(event){
    var block = this 
    const urlParams = new URLSearchParams(window.location.search);
    if (!event){
      var patientId = urlParams.get("patient_id")
      var appointmentId = urlParams.get("appointment_id")
    }else{
      var patientId = $(event.target).attr('data-patientid') 
      var appointmentId = $(event.target).attr('data-appointmentid')
    }

    if (!patientId){
      patientId = $(event.target).parents("td").attr('data-patientid');
    }
    if(!appointmentId){
      appointmentId = $(event.target).parents("td").attr('data-appointmentid');
    }

    $.ajax({
      url:  `${HOST}/api/v1/patients/${patientId}`, 
      headers: { "Authorization": `Token ${TOKEN}` },
      success: function(res){
        var patientParams = res.payload

        // Reset prints buttons
        $("#save_update, #saveprint, #create_visit").show()
        $("#prescription_reprint").attr("data-prescriptionid", null).addClass("d-none")

        fillPatientData(patientParams)
        block.applyAppointmentTabs(res)
        block.loadPatientCategories(patientId)
        
        // Get appointments
        var appointments = res.payload.appointments.filter(a => (a.status == "completed" || a.status == "paid"))
        var mostRecentAppointment = appointments[0];
        var previousAppointment = appointments[1]; // Get the previous appointment
        
        // Check if most recent appointment is today
        var today = new Date().toDateString();
        var mostRecentDate = new Date(mostRecentAppointment.visit_date).toDateString();
        
        // Auto trigger fillAppointment for the most recent appointment
        if (mostRecentAppointment) {
          console.log("mostRecentAppointment", mostRecentAppointment)

          var event = {
            target: $(`#appointmentTab${mostRecentAppointment.id}`)
          };
          block.fillAppointment(event);
          
          // If today's appointment and no report exists yet, pre-populate with previous appointment data
          if (mostRecentDate === today && previousAppointment) {
            $(document).one('fillAppointmentDone', function() {
              var existingReportId = $('input[name="report_id"]').val() || $('input[name="generic_report[id]"]').val();
              if (existingReportId) {
                console.log("Today's report already exists, skipping pre-populate");
                return;
              }
              // Get previous appointment details
              $.ajax({
              url: `${HOST}/api/v1/appointments/${previousAppointment.id}`,
              headers: { "Authorization": `Token ${TOKEN}` },
              success: function(prevRes) {
                var prevAppointment = prevRes.payload;
                if (prevAppointment) {
                  // Pre-populate appointment fields
                  for (const k in prevAppointment) {
                    var prevVal = prevAppointment[k] || "";
                    var $apptElement = $(`#appointment_${k}`);
                    
                    if(!$($apptElement).is("select")){
                      $(`input[name="appointment[${k}]"]`).val(prevVal);
                    }else if ($apptElement.is(":checkbox")){
                      $(`#appointment_${k}`).prop('checked', prevVal);
                    }
                    else if(k.indexOf("_id") == -1){
                      $(`button[data-id='appointment_${k}']`).trigger("click");
                      $(`button[data-id='appointment_${k}']`)
                        .next(".dropdown-menu")
                        .find(`span:contains(${ humanize(prevVal) })`)
                        .parent().trigger("click");
                    }else{
                      $(`#appointment_${k}`).val(prevVal).trigger('change');
                    }
                  }
                  
                  // Load previous investigations
                  $.ajax({
                    url: `${HOST}/generic/get_report?appointment_id=${previousAppointment.id}`,
                    headers: { "Authorization": `Token ${TOKEN}` },
                    success: function(investRes) {
                      console.log("Previous investigations loaded for reference");
            
                      // Clear any existing report_id to ensure we create a new report
                      $('input[name="report_id"]').remove();          
                    }
                  });
                }
              }
            });
            });
          }
        }
      }
    })
  }
  

  changeFields(event) {
    var $el = $(event.target)
    var $form = $el.closest('form')
    var $fieldTypeSelect = $form.find('select[name="field_input[field_type]"]');
    var $singleTextField = $form.find('.single-text-field');
    var $multiSelectField = $form.find('.multi-select-field');

    if ($fieldTypeSelect.val() === 'multi_select') {
      $singleTextField.addClass('d-none');
      $multiSelectField.removeClass('d-none');  
    } else if ($fieldTypeSelect.val() === 'single_text')  {
      $singleTextField.removeClass('d-none');
      $multiSelectField.addClass('d-none');
    }
  }

  addMultipleFields(event) {
    var $el = $(event.target)
    var $form = $el.closest('form')
    var $addOptionButton = $form.find('.add-option');
    var $multiSelectOptions = $form.find('#multi-select-options');

    var newOption = $(`
      <div class="input-group mb-2" style="max-height: 32px;">
        <input class="form-control" type="text" name="field_input[field_input_options_attributes][][value]">
        <div class="input-group-append" style="max-height: inherit;">
          <button class="btn btn-danger remove-option"  
          data-action="click->generic#removeOption" 
          type="button">&times;</button>
        </div>
      </div>
    `);
    $multiSelectOptions.append(newOption);
  }

  removeOption(event) {
    var $el = $(event.target)
    $el.closest('.input-group').remove();
  }

  saveFieldInput(event) {
    event.preventDefault();
    const form = $(event.target);
    let url = form.attr('action');
    let method = form.attr('method'); // Default method from form

    // Extract `_method` from hidden input (Rails' way of handling PATCH/PUT)
    const overrideMethod = form.find('input[name="_method"]').val();
    if (overrideMethod) {
        method = overrideMethod; // Override form method
    }

    // Modify the URL for API calls
    if (method.toLowerCase() === 'post' || method.toLowerCase() === 'patch') {
        url = url.replace('/generic/field_inputs', '/api/v1/field_inputs');
    }

    const formData = new FormData(form[0]);
    const jsonData = { field_input: {} };

    formData.forEach((value, key) => {
      if (key.startsWith('field_input[field_input_options_attributes]')) {
          if (!jsonData.field_input.field_input_options_attributes) {
              jsonData.field_input.field_input_options_attributes = [];
          }

          // Extract the index and potential ID
          const match = key.match(/\[(\d+)?\](?:\[id\]|\[value\])$/);
          if (match && value) {
              const index = match[1] ? parseInt(match[1]) : jsonData.field_input.field_input_options_attributes.length;
              
              if (!jsonData.field_input.field_input_options_attributes[index]) {
                  jsonData.field_input.field_input_options_attributes[index] = {};
              }

              // Assign ID or value correctly
              if (key.endsWith('[id]')) {
                  jsonData.field_input.field_input_options_attributes[index].id = value;
              } else {
                  jsonData.field_input.field_input_options_attributes[index].value = value;
              }
          }
      } else {
          // Handle other normal fields
          jsonData.field_input[key.replace('field_input[', '').replace(']', '')] = value;
      }
    });

    $.ajax({
        url: url,
        method: method,
        contentType: 'application/json', // Ensure it's JSON
        data: JSON.stringify(jsonData), // Convert payload to JSON
        headers: {
            "Authorization": `Token ${TOKEN}`
        },
        success: function(response) {
            console.log('Success:', response);
        },
        error: function(error) {
            console.error('AJAX Error:', error);
        }
    });
  }

  deleteFieldInput(event) {
    event.preventDefault();

    if (!confirm("Are you sure?")) return;

    const button = $(event.target);
    let url = button.attr("href");

    $.ajax({
      url: url,
      method: "DELETE",
      headers: {
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"),
        "Authorization": `Token ${TOKEN}`
      },
      success: function(response) {
        console.log("Success:", response);
        button.closest("form").remove(); // Remove from UI
      },
      error: function(error) {
        console.error("AJAX Error:", error);
      }
    });
  }

  saveReport(event) {
    event.preventDefault();
    
    let form = $(event.target)[0] // Get the form without Stimulus targets
    let formData = new FormData(form);
    let jsonData = {};

    // Convert form data to JSON
    formData.forEach((value, key) => {
      if (key.startsWith("field_input[")) {
        let fieldId = key.match(/\d+/)[0];
        let labelElement = document.querySelector(`[data-field-id="${fieldId}"]`);
        let label = labelElement ? labelElement.innerText.trim() : `field_${fieldId}`;

        let subKey = key.includes("remarks") ? "remarks" : "value";

        if (!jsonData[label]) {
          jsonData[label] = {};
        }

        if (key.includes("[]")) {
          // Multi-select fields should be stored as comma-separated values
          jsonData[label][subKey] = jsonData[label][subKey] ? `${jsonData[label][subKey]},${value}` : value;
        } else {
          jsonData[label][subKey] = value;
        }
      } else {
        jsonData[key] = value;
      }
    });

    var summaryNote = jsonData['summary_note'] || '';
    delete jsonData['summary_note'];
    delete jsonData['authenticity_token']
    delete jsonData['department_id']
    delete jsonData['specialist_id']
    delete jsonData['appointment_id']

    var appointmentId = $("#generic_report_appointment_id").val() || $("#appointment_id").val() || $(".submit-buttons").attr('data-appointmentid') || $(".appts li").find('span.bg-theme').attr('data-appointmentid')
    
    // Try to get report_id from various possible sources
    var reportId = formData.get('report_id') || 
                  formData.get('generic_report[report_id]') ||
                  $('input[name="report_id"]').val() ||
                  $('input[name="generic_report[report_id]"]').val();

    console.log("Report ID found:", reportId);

    var body = {
      generic_report: {
        data: jsonData,
        appointment_id: appointmentId,
        summary_note: summaryNote
      }
    }

    console.log("Submitting JSON:", body);

    // Determine if this is an update or create
    var url = reportId ? `/api/v1/generic_reports/${reportId}` : `/api/v1/generic_reports/`;
    var method = reportId ? "PATCH" : "POST";

    $.ajax({ 
      url: url,
      headers: { "Authorization": `Token ${TOKEN}` },
      method: method,
      data: body,
      success: function(res){
        console.log(res)
        flashToast("Report Saved", "info")
      },
      error: function(res){
        console.log("Error response:", res)
        flashToast("Report Not Saved", "warning")
      }
    });
  }

  // Print the signed prescription using the shared printPage() helper (hidden
  // iframe) — same mechanism as the doctor/pharmacy print, no page navigation.
  printPrescription(event){
    const appointmentId = $(event.currentTarget).attr('data-appointmentid');
    if (!appointmentId){ flashToast("No appointment selected", "warning"); return; }
    flashToast("Preparing prescription…", "info");
    $.get(`/generic/print_prescription?appointment_id=${appointmentId}`)
      .done((res) => {
        if (res && res.content) window.printPage(res.content);
        else flashToast("Could not generate prescription", "warning");
      })
      .fail(() => flashToast("Could not generate prescription", "warning"));
  }

  // ── Patient categories (ported from the prescription panel) ──────────────
  escapeHtml(s){
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, c =>
      ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
  }

  loadPatientCategories(patientId){
    if (!patientId){ $('#patient-categories-container').hide(); return; }
    // Shared across the multiple `data-controller="generic"` instances on the
    // page (navbar / appt-tabs / main). Per-instance `this.currentPatientId`
    // isn't visible to the instance that owns the category input.
    this.currentPatientId = patientId;
    window.__genericPatientId = patientId;
    $.get(`/generic/patient_categories?patient_id=${patientId}`)
      .done((data) => {
        window.patientCategories = data.patient_categories || [];
        window.allCategories = data.all_categories || [];
        this.renderCategories();
        $('#patient-categories-container').show();
      })
      .fail((xhr) => console.error('Error loading patient categories:', xhr.responseText));
  }

  renderCategories(){
    const container = $('#categories-tags-display');
    container.empty();
    (window.patientCategories || []).forEach((category) => {
      container.append($(`
        <span class="category-tag">
          <span class="category-name">${this.escapeHtml(category)}</span>
          <span class="category-remove" data-category="${this.escapeHtml(category)}" data-action="click->generic#removeCategory">×</span>
        </span>`));
    });
  }

  searchCategories(event){
    const term = event.target.value.trim();
    clearTimeout(this._catDebounce);
    this._catDebounce = setTimeout(() => this.renderCategorySuggestions(term), 200);
  }

  showCategorySuggestions(event){
    let term = '';
    if (event && event.target) term = event.target.value.trim();
    else if (typeof event === 'string') term = event;
    this.renderCategorySuggestions(term);
  }

  renderCategorySuggestions(searchTerm = ''){
    const box = $('#categories-suggestions');
    box.empty();
    const all = window.allCategories || [];
    const mine = window.patientCategories || [];

    if (!searchTerm) {
      all.slice(0, 10).forEach((c) => {
        if (!mine.includes(c)) box.append(`<div class="category-suggestion-item" data-category="${this.escapeHtml(c)}">${this.escapeHtml(c)}</div>`);
      });
    } else {
      const filtered = all.filter(c => c.toLowerCase().includes(searchTerm.toLowerCase()) && !mine.includes(c));
      filtered.slice(0, 8).forEach((c) =>
        box.append(`<div class="category-suggestion-item" data-category="${this.escapeHtml(c)}">${this.escapeHtml(c)}</div>`));
      if (filtered.length === 0 && !mine.includes(searchTerm)) {
        box.append(`<div class="category-suggestion-item create-new" data-category="${this.escapeHtml(searchTerm)}">Create new: "${this.escapeHtml(searchTerm)}"</div>`);
      }
    }

    const block = this;
    box.find('.category-suggestion-item').on('click', function(){
      const category = $(this).attr('data-category');
      if (category) { block.addCategory(category); $('#categories-search-input').val(''); box.hide(); }
    });
    box.children().length ? box.show() : box.hide();
  }

  hideCategorySuggestions(event){
    if (event && event.relatedTarget && $(event.relatedTarget).closest('#categories-suggestions').length > 0) return;
    setTimeout(() => $('#categories-suggestions').hide(), 150);
  }

  handleCategoryKeydown(event){
    if (event.key === 'Enter') {
      event.preventDefault();
      const term = event.target.value.trim();
      if (term && !(window.patientCategories || []).includes(term)) {
        this.addCategory(term);
        event.target.value = '';
        $('#categories-suggestions').hide();
      }
    } else if (event.key === 'Escape') {
      $('#categories-suggestions').hide();
      event.target.blur();
    }
  }

  addCategory(categoryName){
    const patientId = this.currentPatientId || window.__genericPatientId;
    if (!patientId || !categoryName) { flashToast("Please select a patient first", "warning"); return; }
    if ((window.patientCategories || []).includes(categoryName)) { flashToast("Category already exists", "warning"); return; }

    const HOST = window.location.origin;
    const TOKEN = window.TOKEN || window.readCookie("_priac_jwt");
    $.ajax({
      url: `${HOST}/api/v1/patients/${patientId}/add_category`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Token ${TOKEN}`, 'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content },
      data: JSON.stringify({ category_name: categoryName })
    })
      .done((response) => {
        if (response.status && response.status.status === "SUCCESS") {
          window.patientCategories = response.payload.categories || [];
          this.renderCategories();
          flashToast(response.status.message || "Category added", "success");
          const all = window.allCategories || [];
          if (!all.includes(categoryName)) { all.push(categoryName); all.sort(); window.allCategories = all; }
        } else {
          flashToast((response.status && response.status.message) || "Error adding category", "warning");
        }
      })
      .fail((xhr) => flashToast(xhr.responseJSON?.status?.message || "Error adding category", "warning"));
  }

  removeCategory(event){
    const categoryName = $(event.currentTarget).attr('data-category');
    const patientId = this.currentPatientId || window.__genericPatientId;
    if (!patientId || !categoryName) return;

    const HOST = window.location.origin;
    const TOKEN = window.TOKEN || window.readCookie("_priac_jwt");
    $.ajax({
      url: `${HOST}/api/v1/patients/${patientId}/remove_category`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Token ${TOKEN}`, 'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content },
      data: JSON.stringify({ category_name: categoryName })
    })
      .done((response) => {
        if (response.status && response.status.status === "SUCCESS") {
          window.patientCategories = response.payload.categories || [];
          this.renderCategories();
          flashToast(response.status.message || "Category removed", "success");
        } else {
          flashToast((response.status && response.status.message) || "Error removing category", "warning");
        }
      })
      .fail((xhr) => flashToast(xhr.responseJSON?.status?.message || "Error removing category", "warning"));
  }

}